import { css } from 'styled-components';

import 'swiper/css';

// Import Swiper styles
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// import swiperCss from '!!raw-loader!swiper/css';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// import swiperNavigation from '!!raw-loader!swiper/css/navigation';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// import swiperPagination from '!!raw-loader!swiper/css/pagination';

export const CssSwiper = css`
  background: transparent;
  /*
  {swiperCss}
  */
  /*
  // !!! todo hide image before initialization
  .swiper:not(.swiper-initialized) {
    .swiper-slide > * {
      display: none;
    }
  }
  */
`;
